import { render, staticRenderFns } from "./FamousCommentItemAll.vue?vue&type=template&id=290f8280&"
import script from "./FamousCommentItemAll.vue?vue&type=script&lang=js&"
export * from "./FamousCommentItemAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports